import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import DashboardFilters from './DashboardFilters';
import DashboardStatCard from './DashboardStatCard';
import DashboardWidgetTable from './DashboardWidgetTable';

const Dashboard = ({ widgets, customers, jobTypes }) => {
    const [filters, setFilters] = useState({ customerId: '', jobTypeId: '' });
    const [expandedIds, setExpandedIds] = useState({});

    const toggle = (id) => setExpandedIds((prev) => ({ ...prev, [id]: !prev[id] }));

    return (
        <>
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <DashboardFilters customers={customers} jobTypes={jobTypes} filters={filters} onChange={setFilters} />
                </div>
                <div className="card-body">
                    <div className="row">
                        {widgets.map((widget) => (
                            <DashboardStatCard
                                key={widget.id}
                                {...widget}
                                filters={filters}
                                expanded={!!expandedIds[widget.id]}
                                onToggle={() => toggle(widget.id)}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className="row">
                {widgets
                    .filter((widget) => expandedIds[widget.id])
                    .map((widget) => (
                        <DashboardWidgetTable
                            key={widget.id}
                            {...widget}
                            filters={filters}
                            onClose={() => toggle(widget.id)}
                        />
                    ))}
            </div>
        </>
    );
};

export default Dashboard;

const el = document.getElementById('dashboard-widgets');
if (el) {
    ReactDOM.render(
        <Dashboard
            widgets={JSON.parse(el.dataset.widgets)}
            customers={JSON.parse(el.dataset.customers)}
            jobTypes={JSON.parse(el.dataset.jobTypes)}
        />,
        el
    );
}
